export default (state = { value: false }, action) => {
  if (action.type === 'CHANGE_SHOW_BURGER_MENU') {
    return { ...state, value: action.show };
  }

  return state;
};
